import { z } from "zod";

const failingSourceValues = ["Unknown", "TokenProvider", "Webhook"] as const;

export const failingSourceSchema = z.enum(failingSourceValues);
